/* eslint-disable jsx-a11y/media-has-caption */
/* eslint-disable react/no-unknown-property */
/* eslint-disable jsx-a11y/iframe-has-title */
import Footer from 'components/intro/Footer';
import { ColDiv, Div, Span, Text } from 'components/intro/Custom';
import vedio from 'components/intro/intro.mp4';
import React from 'react';
import { Icon } from 'components/common/Icon';
import { CustomImage } from 'components/intro/CustomImage';
import background from 'assets/intro/background.svg';

import bannerService from 'services/banner/banner-service';

function Intro(props) {
  React.useEffect(() => {
    bannerService.list(1, 10);
  }, []);
  
  return (
    <>
      <ColDiv $height={950} $sHeight={442} $position="relative" $overflow="hidden" $width="100vw">
        <Icon
          name="logoBlue"
          $height={38}
          $position="absolute"
          $top="40px"
          $sTop="20px"
          $sLeft="20px"
          $left="40px"
          $sHeight={20}
        />
        <Div $height={950} $sHeight={442}>
          <video autoPlay muted style={{ objectFit: 'cover', minWidth: '100vw' }} height="100%">
            <source src={vedio} type="video/webm" />
          </video>
        </Div>
        <ColDiv $position="absolute" $alignItems="center" $justifyContent="center" $width="100%" $height="100%">
          <Text
            style={{ color: 'rgba(255,255,255,0.6)' }}
            $letterSpacing="50px"
            $margin="0 0 0 50px"
            $sMargin="0 0 0 10px"
            $sLetterSpacing="15px"
            $fontSize={96}
            $sFontSize={45}
            $fontWeight={700}
          >
            365일
          </Text>
          <Text $color="white" $letterSpacing="2px" $fontSize={64} $fontWeight={700} $sFontSize={24}>
            신선함이 공급됩니다.
          </Text>
          <Text $maxWidth={700} $textAlign="center" $color="white" $sFontSize={14} $sWidth={180} $marginTop="20px">
            주식회사 팜인은 환경과 공존하는 축산 기술, 동물 복지 구현과 <Span $display="none" $tDisplay="block" />
            휴머니즘 서비스를 제공하는 기업입니다.
          </Text>
        </ColDiv>
      </ColDiv>
      <ColDiv
        $padding="50px 0 232px"
        $sPadding="30px 0 110px"
        $sHeight="unset"
        $position="relative"
        $justifyContent="center"
      >
        <Div $position="relative" $zIndex="1">
          <ColDiv $alignItems="center" $justifyContent="center" $gap={30} $height="100%">
            <Icon name="line" $sHeight={40} />
            <Text
              $fontSize={57}
              $sFontSize={45}
              $letterSpacing="34px"
              $sLetterSpacing="10px"
              $fontWeight={900}
              $color="lightGray"
            >
              WELCOME
            </Text>
            <Text $textAlign="center" $marginTop={20} $sMarinTop="0" $sFontSize={12}>
              주식회사 팜인 홈페이지를 찾아 주셔서 감사합니다.
              <br />
              죄송합니다만 현재는 홈페이지 제작 중에 있습니다.
              <br />
              궁금한 사항은 아래 이메일로 문의 주시면&nbsp;
              <Span $display="none" $sDisplay="block"></Span>
              정성스럽게 답변해 드리겠습니다.
            </Text>
            <Text $fontSize={24} $color="primary" $sFontSize={14}>
              <a href="mailto:farmin0130@farm-in.kr">farmin0130@farm-in.kr</a>
            </Text>
            <Icon name="logoGray" $height={38} $marginTop={20} $sHeight={20} />
          </ColDiv>
        </Div>
        <CustomImage
          $maxWidth={792}
          $width="100%"
          src={background}
          $position="absolute"
          $bottom="0"
          $left="50%"
          $transform="translateX(-50%)"
        />
      </ColDiv>
      <Footer />
    </>
  );
}

export default Intro;
